import { render, staticRenderFns } from "./DiscussionTable.vue?vue&type=template&id=77266a39&"
import script from "./DiscussionTable.vue?vue&type=script&lang=js&"
export * from "./DiscussionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports